<template>
  <b-container fluid="lg">
    <transition name="fade">
      <!-- show loader -->
      <pageLoader
        key="ap-loader-view"
        v-if="$wait.is('loading finalized ap')"
      ></pageLoader>

      <b-jumbotron
        v-else
        key="ap-data-view"
        bg-variant="light"
        text-variant="dark"
        class="mt-4 py-2 px-0"
        border-variant="light"
        header-level="4"
        header-tag="h6"
      >
        <!-- 
					
					header
					
				-->
        <!-- title -->
        <template slot="header" title="template name">
          <span class="text-shadow text-primary">{{ ap.templateName }}</span>
        </template>

        <!-- hr -->
        <b-row style="margin-top: -20px">
          <b-col>
            <hr
              style="
                margin-bottom: 0;
                border-top: 1px solid rgba(39, 162, 252, 0.6);
              "
            />
          </b-col>
        </b-row>

        <!-- description -->
        <b-row style="margin-bottom: 20px; margin-top: -5px">
          <b-col>
            <small v-if="ap.templateDescription">
              <em class="text-muted text-shadow pl-2">{{
                ap.templateDescription
              }}</em>
            </small>
          </b-col>
        </b-row>
        <!--

					BASIC CUSTOMER INFO 
					
				-->
        <div>
          <b-row class="mb-5">
            <b-col cols="12">
              <b-card
                bg-variant="white"
                border-variant="white"
                text-variant="dark"
                class="py-3 shadow-sm"
              >
                <fieldset disabled>
                  <b-row class="my-4">
                    <b-col cols="12" sm="12" xl="12">
                      <!-- customer name -->
                      <b-form-row>
                        <b-col cols="12" sm="12" md="12" lg="8" xl="8">
                          <b-form-group
                            label-cols-sm="5"
                            label-cols-md="5"
                            label-cols-lg="4"
                            label-cols-xl="4"
                            label-align="left"
                            label-align-sm="right"
                            label="Customer Name"
                            label-for="customerName"
                            label-class="text-nowrap"
                          >
                            <b-form-input
                              id="customerName"
                              type="text"
                              name="customerName"
                              v-model="ap.customerName"
                            />
                          </b-form-group>
                        </b-col>
                      </b-form-row>

                      <!-- customer number -->
                      <b-form-row>
                        <b-col cols="12" sm="12" md="12" lg="8" xl="8">
                          <b-form-group
                            label-cols-sm="5"
                            label-cols-md="5"
                            label-cols-lg="4"
                            label-cols-xl="4"
                            label-align="left"
                            label-align-sm="right"
                            label-for="customerNumber"
                            label-class="text-nowrap"
                          >
                            <template slot="label">
                              Customer Number
                              <b-link
                                rel="opener"
                                target="new"
                                :href="
                                  'https://clients.vtx.ch/clients/visualisation_infos.asp?ID_CLIENT=' +
                                  ap.customerNumber
                                "
                                title="go to G2K customer page"
                              >
                                <font-awesome-icon
                                  fixed-width
                                  size="xs"
                                  :icon="['fas', 'external-link-alt']"
                                  class="align-top"
                              /></b-link>
                            </template>

                            <b-form-input
                              id="customerNumber"
                              type="text"
                              name="customerNumber"
                              v-model="ap.customerNumber"
                            />
                          </b-form-group>
                        </b-col>
                      </b-form-row>

                      <!-- service number -->
                      <b-form-row>
                        <b-col cols="12" sm="12" md="12" lg="8" xl="8">
                          <b-form-group
                            label-cols-sm="5"
                            label-cols-md="5"
                            label-cols-lg="4"
                            label-cols-xl="4"
                            label-align="left"
                            label-align-sm="right"
                            label-for="serviceNumber"
                            label-class="text-nowrap"
                          >
                            <template slot="label">
                              Service Number
                              <b-link
                                target="new"
                                rel="opener"
                                :href="
                                  'https://clients.vtx.ch/clients/visualisation_prestation.asp?ID_CLIENT=' +
                                  ap.customerNumber +
                                  '&ID_PRESTATION=' +
                                  ap.serviceNumber
                                "
                                title="go to G2K service page"
                              >
                                <font-awesome-icon
                                  fixed-width
                                  size="xs"
                                  :icon="['fas', 'external-link-alt']"
                                  class="align-top"
                              /></b-link>
                            </template>
                            <b-form-input
                              id="serviceNumber"
                              type="text"
                              name="serviceNumber"
                              v-model="ap.serviceNumber"
                            />
                          </b-form-group>
                        </b-col>
                      </b-form-row>

                      <!-- g2k ticket number -->
                      <b-form-row>
                        <b-col cols="12" sm="12" md="12" lg="8" xl="8">
                          <b-form-group
                            label-cols-sm="5"
                            label-cols-md="5"
                            label-cols-lg="4"
                            label-cols-xl="4"
                            label-align="left"
                            label-align-sm="right"
                            label-for="ticketNumber"
                            label-class="text-nowrap"
                            class="mb-0"
                          >
                            <template slot="label">
                              Ticket Number
                              <b-link
                                target="new"
                                rel="opener"
                                :href="
                                  'http://clients.vtx.ch/home.asp?page=G2000/Tickets/ActionAjoute.aspx?IdTicket=' +
                                  ap.ticketNumber
                                "
                                title="go to G2K ticket page"
                              >
                                <font-awesome-icon
                                  fixed-width
                                  size="xs"
                                  :icon="['fas', 'external-link-alt']"
                                  class="align-top"
                              /></b-link>
                            </template>
                            <b-form-input
                              id="ticketNumber"
                              type="text"
                              name="ticketNumber"
                              v-model="ap.ticketNumber"
                            />
                          </b-form-group>
                        </b-col>
                      </b-form-row>
                    </b-col>
                  </b-row>
                </fieldset>
              </b-card>
            </b-col>
          </b-row>
          <!-- 
					
							Questions 
					
					-->
          <!-- tabs -->
          <b-tabs
            v-model="tabIndex"
            align="right"
            active-nav-item-class="shadow-sm border-white text-warning"
            nav-class="border-0"
          >
            <!-- tab overview -->
            <b-tab title="overview" :disabled="1 > ap.regions.length">
              <template v-slot:title>
                <font-awesome-icon :icon="['far', 'file-alt']" />&nbsp;overview
              </template>
              <!-- 
					
							tab overview context
					
							-->
              <b-card
                v-if="ap.regions.length > 0"
                border-variant="white"
                class="shadow-sm"
              >
                <fieldset disabled>
                  <b-card
                    v-for="(region, index) in ap.regions"
                    :key="'region' + index"
                    border-variant="white"
                    no-body
                  >
                    <!-- title -->
                    <b-card-title
                      :class="index == 0 ? 'mt-3' : 'mt-5'"
                      class="region-title text-info rounded-top font-weight-bold mb-0 py-2 pl-2"
                    >
                      {{ region.title }}
                      <span class="region-subtitle font-weight-normal"
                        >&nbsp;-&nbsp;{{ region.description }}</span
                      >
                      <!-- sub title -->
                    </b-card-title>

                    <!-- questions container -->
                    <b-list-group class="question-container mt-3">
                      <!-- each question -->
                      <b-list-group-item
                        v-for="question in region.questions"
                        :key="question.id + region.id"
                        class="border-left-0 border-right-0"
                      >
                        <!-- question row -->
                        <div class="d-flex align-items-center">
                          <!-- question title-->
                          <div
                            :title="question.description"
                            style="max-width: 80%"
                          >
                            <span class="text-shadow text-info"
                              >{{ question.title }}?</span
                            >
                          </div>
                          <!-- answers -->
                          <b-form-group
                            class="mt-md-0 mt-lg-0 mt-xl-0 mb-0 mt-3 ml-auto"
                            label
                          >
                            <b-form-radio-group
                              v-model="question.answered"
                              align="right"
                            >
                              <b-form-radio value="0" class="negative">
                                <span>{{ question.negativeAnswer }}</span>
                              </b-form-radio>
                              <b-form-radio value="1" class="positive">
                                <span>{{ question.positiveAnswer }}</span>
                              </b-form-radio>
                            </b-form-radio-group>
                          </b-form-group>
                        </div>
                        <b-row
                          v-if="
                            question.comment !== '' && question.comment !== null
                          "
                        >
                          <b-col offset-xl="3">
                            <div
                              class="bg-light d-flex justify-content-start h-100 rounded p-2"
                            >
                              <div class="text-secondary h-100 mr-2">
                                <font-awesome-icon :icon="['fas', 'comment']" />
                              </div>
                              <em>
                                <small class="text-body">{{
                                  question.comment
                                }}</small>
                              </em>
                            </div>
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                    </b-list-group>
                  </b-card>
                </fieldset>
              </b-card>
            </b-tab>
            <!-- ¨
						
						tab stats 
						
						-->
            <b-tab apptitle="stats">
              <template v-slot:title>
                <font-awesome-icon :icon="['fas', 'chart-pie']" />&nbsp;stats
              </template>
              <!-- 
					
							tab Stats context
					
							-->

              <!-- by answer feels -->
              <b-row v-if="ap.regions.length > 0" class="mb-5">
                <b-col cols="12">
                  <b-card
                    bg-variant="white"
                    border-variant="white"
                    text-variant="dark-soft"
                    class="top-right-no-radius shadow-sm"
                  >
                    <b-card-sub-title class="mb-5"
                      >Work-Report stats:</b-card-sub-title
                    >

                    <b-row>
                      <b-col cols="12" sm="6">
                        <b-list-group variant="white" flush>
                          <b-list-group-item
                            class="d-flex justify-content-between align-items-center"
                          >
                            Total questions
                            <b-badge variant="primary" pill>{{
                              byAnswerFeel.all.count
                            }}</b-badge>
                          </b-list-group-item>

                          <b-list-group-item
                            class="d-flex justify-content-between align-items-center"
                          >
                            Positive answered
                            <div>
                              <em class="text-body">
                                <small
                                  >{{ byAnswerFeel.positive.percentage }}%
                                  &nbsp;</small
                                >
                              </em>
                              <b-badge variant="success" pill>{{
                                byAnswerFeel.positive.count
                              }}</b-badge>
                            </div>
                          </b-list-group-item>

                          <b-list-group-item
                            class="d-flex justify-content-between align-items-center"
                          >
                            Negative answered
                            <div>
                              <em class="text-body">
                                <small
                                  >{{ byAnswerFeel.negative.percentage }}%
                                  &nbsp;</small
                                >
                              </em>
                              <b-badge variant="danger" pill>{{
                                byAnswerFeel.negative.count
                              }}</b-badge>
                            </div>
                          </b-list-group-item>
                          <b-list-group-item
                            class="d-flex justify-content-between align-items-center"
                          >
                            Not answered
                            <div>
                              <em class="text-body">
                                <small
                                  >{{ byAnswerFeel.unanswered.percentage }}%
                                  &nbsp;</small
                                >
                              </em>
                              <b-badge variant="warning" pill>{{
                                byAnswerFeel.unanswered.count
                              }}</b-badge>
                            </div>
                          </b-list-group-item>
                        </b-list-group>
                      </b-col>
                      <b-col cols="12" sm="6">
                        <pieChart
                          :chartData="chartData"
                          :options="chartOptions"
                          :styles="chartStyle"
                        ></pieChart>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
              <!--

								meta 

							-->
              <b-row>
                <b-col cols="12">
                  <b-card
                    bg-variant="white"
                    border-variant="white"
                    text-variant="dark-soft"
                    class="top-right-no-radius shadow-sm"
                  >
                    <div v-if="ap.meta.length > 0">
                      <b-card-sub-title class="mb-5"
                        >Closure stats:</b-card-sub-title
                      >
                      <!--

												closure table

											-->
                      <b-table-lite
                        small
                        responsive
                        borderless
                        :items="ap.meta"
                        :fields="metaField"
                        tbody-tr-class="single-closure-row"
                      >
                        <!-- link to that closure -->
                        <template v-slot:cell(url)="data">
                          <b-link
                            :to="{
                              name: 'closure',
                              params: { slug: data.item.url },
                            }"
                            >{{ data.item.url }}</b-link
                          >&nbsp;
                          <!-- if the pdf has been download by the customer, show th number of downloads-->
                          <span
                            v-if="data.item.pdfDownloadedCount > 0"
                            class="text-success"
                            title="the number of times the pdf has been downloaded by the customer"
                          >
                            <font-awesome-icon
                              fixed-width
                              :icon="['fas', 'download']"
                            />
                            <small
                              >&nbsp;{{ data.item.pdfDownloadedCount }}</small
                            >
                          </span>
                          &nbsp;
                          <!-- number of times the link has been clicked-->
                          <span
                            v-if="data.item.linkClickCount > 0"
                            class="text-primary"
                            title="the number of times customer successfully logged in"
                          >
                            <font-awesome-icon
                              fixed-width
                              size="xs"
                              :icon="['fas', 'link']"
                            />
                            <small>&nbsp;{{ data.item.linkClickCount }}</small>
                          </span>
                          <br />
                          <small>{{ formatDate(data.item.created_at) }}</small>
                        </template>

                        <!-- closure result -->
                        <template v-slot:cell(closure_result)="data">
                          <div
                            v-if="
                              data.item.result && data.item.result.length !== 0
                            "
                          >
                            <!-- 
															progress bar 
														-->
                            <closureQuestionStarStatBar
                              :apMetaStats="apMetaStats[data.index]"
                            ></closureQuestionStarStatBar>
                            <!-- 
															closure questions
														-->
                            <b-list-group flush class="mt-4">
                              <b-list-group-item
                                v-for="q in data.item.result"
                                :key="q.id + '-' + data.item.id"
                              >
                                <div
                                  class="d-flex justify-content-between align-items-center"
                                >
                                  <span>{{ q.title }}</span>

                                  <!-- stars -->
                                  <vue-stars
                                    :name="
                                      q.id +
                                      '-' +
                                      data.item.id +
                                      '-closure-question'
                                    "
                                    active-color="#008dcb"
                                    shadow-color="#8080ff"
                                    hover-color="#337ab7"
                                    :value="q.pivot.value"
                                    readonly
                                    class="fa"
                                  >
                                    <span slot="activeLabel">
                                      <font-awesome-icon
                                        :icon="['fas', 'star']"
                                      />
                                    </span>
                                    <span slot="inactiveLabel">
                                      <font-awesome-icon
                                        :icon="['far', 'star']"
                                      />
                                    </span>
                                  </vue-stars>
                                </div>
                                <!-- comment -->
                                <div
                                  v-if="q.pivot.comment"
                                  class="bg-light d-flex justify-content-start h-100 rounded p-2"
                                >
                                  <div class="text-secondary h-100 mr-2">
                                    <font-awesome-icon
                                      :icon="['fas', 'comment']"
                                    />
                                  </div>
                                  <em>
                                    <small class="text-body">{{
                                      q.pivot.comment
                                    }}</small>
                                  </em>
                                </div>
                              </b-list-group-item>
                            </b-list-group>
                          </div>
                          <div v-else class="text-warning text-center">
                            <em>
                              <small>no response from the customer, yet</small>
                            </em>
                          </div>
                        </template>
                      </b-table-lite>

                      <!-- 
												create new closure url and send it to the customer button 
											-->
                      <!-- <b-button
                        v-if="ap.closureOnly !== 1"
                        @click.prevent="onCreateCustomerLink"
                        :disabled="$wait.is('creating customer url')"
                        variant="primary"
                      >
                        <v-wait for="creating customer url">
                          <template slot="waiting">
                            <font-awesome-icon
                              :icon="['fas', 'circle-notch']"
                              spin
                            />&nbsp;Creating...
                          </template>
                          <font-awesome-icon :icon="['fas', 'link']" />
                          &nbsp;Create Closure URL and send Email to the
                          {{ ap.customerEmailAddress }}
                        </v-wait>
                      </b-button> -->

                      <!-- add attachment to email that will be sent to customer -->
                      <b-dropdown
                        split
                        right
                        class="m-2"
                        v-if="ap.closureOnly !== 1"
                        @click.prevent="onCreateCustomerLink"
                        :disabled="$wait.is('creating customer url')"
                        variant="outline-primary"
                        split-button-type="button"
                        split-variant="primary"
                      >
                        <template #button-content>
                          <v-wait for="creating customer url">
                            <template slot="waiting">
                              <font-awesome-icon
                                :icon="['fas', 'circle-notch']"
                                spin
                              />&nbsp;Creating...
                            </template>
                            <font-awesome-icon :icon="['fas', 'link']" />
                            &nbsp;Create Closure URL and send Email to the
                            {{ ap.customerEmailAddress }} &nbsp;
                            <small
                              v-show="attachToEmail.length > 0"
                              class="align-text-top"
                              title="number of attachments that will be attached to email"
                            >
                              ({{ attachToEmail.length }})
                            </small>
                          </v-wait>
                        </template>

                        <b-dropdown-header id="dropdown-header-label">
                          <p
                            class="text-lowercase text-primary font-weight-normal h6 px-2 py-1"
                          >
                            <font-awesome-icon
                              :icon="['fas', 'paperclip']"
                            />&nbsp; Select attachments you want to add to
                            E-Mail
                          </p>
                        </b-dropdown-header>

                        <b-dropdown-form>
                          <template>
                            <b-form-checkbox-group
                              v-model="attachToEmail"
                              :options="ap.attachments"
                              text-field="title"
                              value-field="name"
                              stacked
                            >
                            </b-form-checkbox-group>
                          </template>
                        </b-dropdown-form>
                      </b-dropdown>
                    </div>
                    <!-- 
											closure url was never created 
										-->
                    <div v-else>
                      <b-alert show variant="warning" class="my-0 text-center">
                        <small>
                          The Closure URL has been never sent to the customer.
                          Click to&nbsp;

                          <b-dropdown
                            split
                            right
                            class="m-2"
                            v-if="ap.closureOnly !== 1"
                            @click.prevent="onCreateCustomerLink"
                            :disabled="$wait.is('creating customer url')"
                            variant="outline-primary"
                            split-button-type="button"
                            split-variant="primary"
                          >
                            >
                            <template #button-content>
                              <v-wait for="creating customer url">
                                <template slot="waiting">
                                  <font-awesome-icon
                                    :icon="['fas', 'circle-notch']"
                                    spin
                                  />&nbsp;Creating...
                                </template>
                                <font-awesome-icon
                                  :icon="['fas', 'link']"
                                />&nbsp;create customer link
                                <small
                                  v-show="attachToEmail.length > 0"
                                  class="align-text-top"
                                  title="number of attachments that will be attached to email"
                                >
                                  ({{ attachToEmail.length }})
                                </small>
                              </v-wait>
                            </template>

                            <b-dropdown-header id="dropdown-header-label">
                              <p
                                class="text-lowercase text-primary font-weight-normal h6 px-2 py-1"
                              >
                                <font-awesome-icon
                                  :icon="['fas', 'paperclip']"
                                />&nbsp; Select attachments you want to add to
                                E-Mail
                              </p>
                            </b-dropdown-header>

                            <b-dropdown-form>
                              <template>
                                <b-form-checkbox-group
                                  v-model="attachToEmail"
                                  :options="ap.attachments"
                                  text-field="title"
                                  value-field="name"
                                  stacked
                                >
                                </b-form-checkbox-group>
                              </template>
                            </b-dropdown-form>
                          </b-dropdown>

                          &nbsp;and send email to
                          <ins>{{ ap.customerEmailAddress }}</ins>
                        </small>
                      </b-alert>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>

            <!-- attachments  -->
            <b-tab :disabled="ap.attachments.length < 1" apptitle="Attachments">
              <template v-slot:title>
                <span>
                  <font-awesome-icon
                    :icon="['fas', 'paperclip']"
                  />&nbsp;Attachments
                  <small class="text-body align-top"
                    >({{ ap.attachments.length }})</small
                  >
                </span>
              </template>
              <!-- 
					
							tab attachments context
					
							-->
              <b-row v-if="ap.attachments.length > 0" class="mb-5">
                <b-col cols="12">
                  <b-card
                    bg-variant="white"
                    border-variant="white"
                    text-variant="dark-soft"
                    class="top-right-no-radius shadow-sm"
                  >
                    <b-card-sub-title class="mb-5"
                      >Attached Files:</b-card-sub-title
                    >

                    <b-row>
                      <b-col
                        v-for="(attachment, index) in ap.attachments"
                        :key="index + 'att'"
                        cols="12"
                        sm="6"
                        md="6"
                        lg="4"
                        xl="3"
                      >
                        <!-- attachments thumbnail, click on this trigger sidebar with big preview -->
                        <attachmentFileShow
                          :attachment="attachment"
                          :uuid="ap.uuid"
                          @previewAttachment="previewAttachment"
                        >
                        </attachmentFileShow>
                      </b-col>
                    </b-row>
                    <!-- sidebar with big preview -->
                    <slideSideBar
                      :previewBarVisible="previewBarVisible"
                      :attachment="attachmentToPreview"
                      @closeMe="previewBarVisible = false"
                      @showAttachment="previewPrevNextAttachment"
                    ></slideSideBar>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
          <!-- 							
						
							place, date...

					-->
          <b-row>
            <b-col cols="12" sm="12" xl="12">
              <b-card class="mt-5 rounded bg-white pt-3 shadow-sm">
                <fieldset disabled>
                  <!-- place -->
                  <b-form-row v-if="ap.closureOnly !== 1">
                    <b-col cols="12" sm="12" md="12" lg="6" xl="8">
                      <b-form-group
                        label-cols-sm="5"
                        label-cols-md="5"
                        label-cols-lg="5"
                        label-cols-xl="4"
                        label-align="left"
                        label-align-sm="right"
                        label="Place:"
                        label-for="place"
                      >
                        <b-form-input
                          id="place"
                          type="text"
                          name="place"
                          v-model="ap.place"
                        />
                      </b-form-group>
                    </b-col>
                  </b-form-row>

                  <!-- customer email -->
                  <b-form-row>
                    <b-col cols="12" sm="12" md="12" lg="6" xl="8">
                      <b-form-group
                        label-cols-sm="5"
                        label-cols-md="5"
                        label-cols-lg="5"
                        label-cols-xl="4"
                        label-align="left"
                        label-align-sm="right"
                        label="Customer Email:"
                        label-for="customerEmailAddress"
                      >
                        <b-form-input
                          v-model.trim="ap.customerEmailAddress"
                          id="customerEmailAddress"
                          type="text"
                          name="customerEmailAddress"
                        />
                      </b-form-group>
                    </b-col>
                  </b-form-row>

                  <!-- comment -->
                  <b-form-row class="mt-4">
                    <b-col cols="12" sm="12" md="12" lg="11" xl="11">
                      <b-form-group
                        label-cols-sm="1"
                        label-cols-md="1"
                        label-cols-lg="1"
                        label-cols-xl="1"
                        label-align="left"
                        label-align-sm="right"
                        label="Comment:"
                        label-for="comment"
                        label-class="d-flex justify-content-start justify-content-sm-end"
                      >
                        <template slot="label">
                          <font-awesome-icon
                            size="2x"
                            class="text-body align-self-center"
                            :icon="['fas', 'comment']"
                          />
                        </template>
                        <p
                          v-html="ap.comment"
                          class="bg-light text-body h-100 rounded p-3"
                        ></p>
                      </b-form-group>
                    </b-col>
                  </b-form-row>
                  <!-- 							
						
									signature

									-->
                  <b-row>
                    <b-col cols="12">
                      <b-form-group id="signatures" class="mt-5">
                        <b-row>
                          <!-- installer -->
                          <b-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="6"
                            ref="signatureParentEl"
                          >
                            <b-row>
                              <b-col cols="12">
                                <b-form-group
                                  label-cols-sm="5"
                                  label-cols-md="5"
                                  label-cols-lg="5"
                                  label-cols-xl="4"
                                  label-align="left"
                                  label-align-sm="right"
                                  label="Installer:"
                                  label-for="installedBy"
                                >
                                  <b-form-input
                                    id="installedBy"
                                    type="text"
                                    name="installedBy"
                                    v-model="ap.installedBy"
                                  />
                                </b-form-group>
                              </b-col>
                            </b-row>
                            <!-- installer signature-->
                            <b-row v-if="ap.closureOnly !== 1">
                              <b-col>
                                <div
                                  style="height: 187px"
                                  class="img-fluid rounded border"
                                >
                                  <b-img
                                    @error="imgPlaceholder"
                                    :src="
                                      '/backend/storage/user/' +
                                      this.ap.installer_id +
                                      '/signature.png'
                                    "
                                    class="img-fluid"
                                    alt="installer signature"
                                  />
                                </div>
                              </b-col>
                            </b-row>
                          </b-col>
                          <!-- customer -->
                          <b-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="6"
                            class="my-lg-0 mb-1 mt-5"
                          >
                            <b-form-row>
                              <b-col cols="12">
                                <b-form-group
                                  label-cols-sm="5"
                                  label-cols-md="5"
                                  label-cols-lg="5"
                                  label-cols-xl="4"
                                  label-align="left"
                                  label-align-sm="right"
                                  label="Customer:"
                                  label-for="customerSignedBy"
                                >
                                  <b-form-input
                                    id="customerSignedBy"
                                    type="text"
                                    name="customerSignedBy"
                                    v-model="ap.customerSignedBy"
                                  />
                                </b-form-group>
                              </b-col>
                            </b-form-row>
                            <!-- customer signature -->
                            <b-row v-if="ap.closureOnly !== 1">
                              <b-col>
                                <div
                                  style="height: 187px"
                                  class="rounded border"
                                >
                                  <b-img
                                    :src="getImageUrl('customer')"
                                    class="img-fluid"
                                    alt="installer signature"
                                  />
                                </div>
                              </b-col>
                              <b-col cols="12" class="text-right">
                                <em class="text-muted">
                                  <small>
                                    the Protocol has been signed on
                                    {{ formatDate(ap.signed_on) }}
                                  </small>
                                </em>
                              </b-col>
                            </b-row>
                          </b-col>
                          <!--/ customer -->
                        </b-row>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <!-- show time spent (closure only)-->
                  <b-row v-if="ap.closureOnly == 1">
                    <b-col cols="12" class="text-body text-right">
                      <em v-show="this.ap.timeSpent !== null">
                        the time spent onsite: {{ ap.timeSpent }} minutes
                        <span class="text-secondary">
                          ({{ timeSpentFormatted }} )
                        </span>
                      </em>
                    </b-col>
                  </b-row>
                </fieldset>
              </b-card>
            </b-col>
          </b-row>
        </div>

        <!-- action buttons -->
        <b-form-group v-if="ap.closureOnly !== 1">
          <b-row class="mt-5">
            <!-- time spent  on -->
            <b-col
              cols="12"
              sm="12"
              md="12"
              lg="8"
              xl="8"
              order="3"
              order-sm="2"
              order-md="2"
              order-lg="1"
              order-xl="1"
              class="align-self-end mt-sm-2 mt-md-2 mt-lg-0 mt-xl-0 mt-2 text-right"
            >
              <!-- show time spent -->
              <em v-show="this.ap.timeSpent !== null">
                the time spent onsite: {{ ap.timeSpent }} minutes
                <span class="text-secondary"> ({{ timeSpentFormatted }}) </span>
              </em>
            </b-col>
            <b-col
              cols="12"
              sm="12"
              md="12"
              lg="4"
              xl="4"
              order="2"
              order-sm="1"
              order-md="1"
              order-lg="2"
              order-xl="2"
              class="mt-sm-0 mt-2"
            >
              <b-button
                @click.prevent="getPdf"
                :disabled="$wait.is('getting pdf')"
                variant="success"
                block
              >
                <v-wait for="getting pdf">
                  <template slot="waiting">
                    <font-awesome-icon
                      :icon="['fas', 'circle-notch']"
                      spin
                    />&nbsp;Fetching...
                  </template>
                  <font-awesome-icon :icon="['far', 'file-pdf']" />&nbsp;Show
                  PDF
                </v-wait>
              </b-button>
            </b-col>
          </b-row>
        </b-form-group>
      </b-jumbotron>
    </transition>
  </b-container>
</template>

<script>
import { addMinutes, formatDistance } from "date-fns";
import { flatMap, last } from "lodash";
import { mapActions, mapState } from "vuex";

import attachmentFileShow from "@/components/attachments/attachmentFileShow.vue";
import slideSideBar from "@/components/attachments/attachmentSideBarShow.vue";
import pieChart from "@/components/charts/pieChart.vue";
import closureQuestionStarStatBar from "@/components/closureQuestionStarStatBar.vue";
import pageLoader from "@/components/utils/wholePageLoader.vue";

import metaStarsStat from "@/mixins/metaStarsStat.js";
import questionsByFeel from "@/mixins/questionsByFeel.js";
import AttachmentFileShow from "../../components/attachments/attachmentFileShow.vue";

export default {
  name: "apFinalizedShow_view",

  components: {
    pageLoader,
    pieChart,
    closureQuestionStarStatBar,
    attachmentFileShow,
    slideSideBar,
    AttachmentFileShow,
  },

  mixins: [questionsByFeel, metaStarsStat],

  data() {
    return {
      metaField: [
        {
          key: "url",
          label: "URL",
        },
        {
          key: "sent_by.name",
          label: "Sent by",
        },
        {
          key: "closure_result",
          label: "",
          tdClass: "w-50",
        },
      ],
      attachmentToPreview: {
        title: null,
        src: null,
        comment: null,
      }, // active preview attachment shown in sidebar
      previewBarVisible: false,
      // array of attachments that will be attached and send to customer with URL Email
      attachToEmail: [],
    };
  },

  computed: {
    // which tab should be shown
    tabIndex: {
      // getter
      get: function () {
        return this.ap.closureOnly === 1 ? 1 : 0;
      },
      set: function () {},
    },

    // get the stats data for meta
    apMetaStats() {
      return this.metaStats(this.ap.meta);
    },

    ...mapState("apFinalized", {
      ap: "item",
    }),

    // get all questions merged in one array
    questions() {
      let questions = flatMap(this.ap.regions, function (item) {
        return item.questions;
      });
      return questions;
    },

    // format time spent - humanize
    timeSpentFormatted() {
      return this.ap.timeSpent == null
        ? null
        : formatDistance(
            new Date(0),
            addMinutes(new Date(0), this.ap.timeSpent)
          );
    },

    // by feel chart options
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        rotation: 1 * Math.PI,
        circumference: 1 * Math.PI,
        legend: {
          display: false,
        },
      };
    },

    // by feel chart style, object with css styles for the surrounding div container
    chartStyle() {
      return {
        height: "200px",
        position: "relative",
      };
    },

    // by feel chart data
    chartData() {
      return {
        labels: ["Positive", "Negative", "Not Answered"],
        borderColor: "blue",
        borderWidth: 5,

        datasets: [
          {
            label: "Data One",
            backgroundColor: ["#37bd74", "#e8286b", "#ff9b37"],

            data: [
              this.byAnswerFeel.positive.count,
              this.byAnswerFeel.negative.count,
              this.byAnswerFeel.unanswered.count,
            ],
          },
        ],
      };
    },
  },

  methods: {
    ...mapActions("apFinalized", ["GET_PDF", "CREATE_CUSTOMER_URL"]),

    // clicked on the create closure url and send it to customer email
    onCreateCustomerLink() {
      if (this.ap.meta.length > 0) {
        this.$bvModal
          .msgBoxConfirm(
            "The Email has already been sent to the customer. Are you sure that you want to send the new one?",
            {
              title: "Please Confirm",
              buttonSize: "sm",
              okVariant: "primary",
              okTitle: "Send Email to the Customer",
              cancelVariant: "light",
              cancelTitle: "Cancel",
              footerClass: "p-2",
            }
          )
          .then((value) => {
            if (value) this.createCustomerLink();
          })
          .catch((err) => {
            console.error("error in modal: ", err);
          });
      } else {
        this.createCustomerLink();
      }
    },

    // go execute create new closure url and send email to the customer
    createCustomerLink() {
      this.$wait.start("creating customer url");

      this.$store
        .dispatch("apFinalized/CREATE_CUSTOMER_URL", {
          id: this.$route.params.id,
          attachments: this.attachToEmail,
        })
        .then(
          () => {
            this.$wait.end("creating customer url");
            this.showToast(
              "success",
              "Done",
              "The customer link has been created and the email has been sent."
            );
          },
          (error) => {
            this.showToast("danger", error.statusText, error.data.message);
            this.$wait.end("creating customer url");
          }
        );
    },

    // get ap as pdf file (work-report.pdf)
    getPdf() {
      fetch(
        "/backend/storage/ap/finalized/" + this.ap.uuid + "/work-report.pdf"
      )
        .then((res) => res.arrayBuffer())
        .then((res) => {
          const file = new Blob([res], { type: "application/octet-stream" });
          const fileURL = URL.createObjectURL(file);
          const link = document.createElement("a");
          link.href = fileURL;
          link.download = "work-report.pdf";
          link.click();
          link.remove();
        });
    },

    // get the signature url
    // @whichSig = string, which signature to be shown (installer || customer)
    getImageUrl(whichSig = false) {
      if (!whichSig)
        console.error("I don't know which signature I should show you");
      const sigUrl = this.ap.customerSignature
        ? "/backend/storage/ap/finalized/" +
          this.ap.uuid +
          "/" +
          whichSig +
          "Signature.png?"
        : "/backend/storage/ap/sored-wo-sig.png";
      return sigUrl;
    },

    // preview the attachment (in sidebar)
    previewAttachment(attachment) {
      // find index of that attachment by title in form array (to update comment if needed)
      const index = this.ap.attachments.findIndex(
        (item) => item.id == attachment.id
      );

      // assign model
      this.attachmentToPreview = this.ap.attachments[index];
      this.attachmentToPreview.meta = { i: index };

      // show sidebar
      this.previewBarVisible = true;
    },

    // clicked on next/prev button
    previewPrevNextAttachment(direction) {
      // if there is only one attachment, nothing to roll
      if (this.ap.attachments.length < 1) return;

      let a;

      // if clicked on prev button
      if (direction === "prev") {
        // if the current shown attachments is first, get the last one,
        // otherwise -1
        a =
          this.attachmentToPreview.meta.i == 0
            ? last(this.ap.attachments)
            : this.ap.attachments[this.attachmentToPreview.meta.i - 1];
      } else if (direction === "next") {
        // if the current shown attachments is last, get the first one,
        // otherwise +1
        a =
          this.attachmentToPreview.meta.i == this.ap.attachments.length - 1
            ? this.ap.attachments[0]
            : this.ap.attachments[this.attachmentToPreview.meta.i + 1];
      }

      if (a) this.previewAttachment(a);
    },

    // if no installer sig found, show default one
    imgPlaceholder(e) {
      e.target.src = "/backend/storage/user/no-signature-found.png";
    },
  },

  // created hook
  created() {
    this.$wait.start("loading finalized ap");
  },

  // mounted hook
  mounted() {
    // fetch accept-protocol
    this.$store
      .dispatch("apFinalized/GET_AP_FINALIZED_BY_ID", {
        id: this.$route.params.id,
      })
      .then(
        () => {
          this.$wait.end("loading finalized ap");
        },
        (error) => {
          this.$wait.end("loading finalized ap");
          this.showToast("danger", error.statusText, error.data.message);
        }
      );
  },
};
</script>
<style>
tr.single-closure-row:not(:first-child) {
  border-top: 1px solid rgba(39, 162, 252, 0.6);
}

tr.single-closure-row:not(:first-child) td {
  padding-top: 40px;
}
</style>
